/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { AuthFooterLinks } from './components/FooterLinks'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid'>
      {/* begin::Body */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 h-100 p-8'>
        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          {/* begin::Wrapper */}
          <div className='w-100 w-sm-450px w-xl-500px w-xxl-600px pb-10 p-lg-10'>
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}
        {/* begin::Visual */}
        {/* <div className='d-flex d-lg-none d-flex flex-center'>
          <div className='text-center rounded-3 bgi-gradient p-10'>
            <div className='mb-5'>
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/ofindo_logo_compact-dark.svg')} width='150px' />
            </div>
            {/* end::Logo */}

        {/* begin::Title */}{/*
            <div className='w-50 m-auto'>
              <h1 className='text-center text-white fs-2qx'>
                Mit Ofindo erreichen Sie die Menschen in Oldenburg {/*<br /><div className='fs-1 rounded-1 px-4 py-1 bg-danger mt-5 d-inline-block'>Kostenlos</div>*/}{/*
              </h1>
            </div>
          </div>
        </div>*/}
        {/* end::Visual */}
        <AuthFooterLinks />
      </div>
      {/* end::Body */}
      {/* begin::Aside */}
      <div className='d-flex flex-lg-row-fluid mt-sm-15 w-lg-50 d-none d-lg-block w-100'>

        {/* begin::Content */}
        <div className='d-flex flex-column text-center pt-10 position-fixed w-50 h-100 rounded-top-start-lg-5 bgi-gradient-dark'>
          {/* begin::Logo */}
          <div className='mt-5 mb-5 mt-md-10 mb-md-5 mb-xl-10'>
            <img alt='Logo' src={toAbsoluteUrl('/media/logos/ofindo_logo_compact-dark.svg')} width='150px' />
          </div>
          {/* end::Logo */}

          {/* begin::Title */}
          <div className='text-center'>
            <h1 className='text-center text-white fs-2qx mb-5'>
              Mit Ofindo die Menschen in Oldenburg erreichen {/*<br /><div className='fs-1 rounded-1 px-4 py-1 bg-danger mt-5 d-inline-block'>Kostenlos</div>*/}
            </h1>
          </div>
          {/* end::Title */}

          {/* begin::CTA */}
          {/*<div className='text-center'>
              <a className="btn btn-success" href='https://partner.ofindo.de' target='_blank' rel="noreferrer">
                <span>Mehr erfahren</span>
              </a>
            </div>*/}
          {/* end::CTA */}

          <div
            className='d-none d-lg-block authImgRightBottom'
            style={{ backgroundImage: `url(${toAbsoluteUrl('/media/misc/auth-bg.png')})` }}
          ></div>

        </div>
        {/* end::Content */}
      </div>
      {/* end::Aside */}
    </div >
  )
}

export { AuthLayout }
